/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Pagination } from 'semantic-ui-react';

function DefaultPagination({
  activePage,
  totalCount,
  pageSize,
  onPageChange,
  onPageChangeV2,
  ...rest
}) {
  const handlePageChange = (event, paginationProps) => {
    // prioritize using onPageChangeV2 first
    if (onPageChangeV2) {
      onPageChangeV2(paginationProps.activePage);
    }

    if (onPageChange) {
      onPageChange(event, paginationProps);
    }
  };

  return (
    <Pagination
      activePage={activePage}
      totalPages={Math.ceil(totalCount / pageSize)}
      onPageChange={handlePageChange}
      {...rest}
    />
  );
}

DefaultPagination.propTypes = {
  activePage: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  onPageChange: PropTypes.func,
  onPageChangeV2: PropTypes.func, // FIXME: This only give argument of newly requested page, maybe deprecate the older and rename this later
};

DefaultPagination.defaultProps = {
  onPageChange: null,
  onPageChangeV2: null,
};

export default DefaultPagination;
